import React from 'react';
import { Trans } from 'react-i18next';
import { CatalogSource } from '@1po/1po-bff-fe-spec/generated/common/vehicle/CatalogSource';
import { ExclamationTriangleIcon, PictureIcon } from 'assets/icons';
import { theme } from 'styles';
import { CenterFlex, Icon, Image, Text, URL } from 'UI';
import { ProductImageBackground, ProductImageUnavailable } from './ProductImage.styled';

const DefaultProductImage = () => <Icon IconComponent={PictureIcon} width={200} height={220} />;

export interface ProductImageProps {
  imageUrl: string | undefined;
  catalogSource: CatalogSource;
  alt: string;
  availableInUserCountry?: boolean;
  localImage?: boolean;
  maxImageHeight?: number;
}

export const ProductImage = ({
  imageUrl,
  catalogSource,
  alt,
  availableInUserCountry,
  localImage,
  maxImageHeight = 450,
}: ProductImageProps) => {
  return (
    <>
      {availableInUserCountry || localImage ? (
        <ProductImageBackground>
          <CenterFlex>
            {localImage ? (
              <Image
                src={imageUrl}
                catalogSource={catalogSource}
                alt={alt}
                maxWidth={'100%'}
                maxHeight={maxImageHeight}
                cursor={'zoomin'}
              />
            ) : (
              <Image
                src={imageUrl}
                type={URL}
                catalogSource={catalogSource}
                alt={alt}
                cursor={'zoomin'}
                maxWidth={'100%'}
                maxHeight={maxImageHeight}
                fallbackComponent={<DefaultProductImage />}
              />
            )}
          </CenterFlex>
        </ProductImageBackground>
      ) : (
        <ProductImageUnavailable direction={'column'} align={'center'} justify={'center'} padding={'0 10px'} size={0}>
          <Icon IconComponent={ExclamationTriangleIcon} width={150} height={100} color={theme.color.shadow_6} />
          <Text type={'h1_banner_black_45'}>
            <Trans i18nKey={'catalog.product.unavailable'}>Unavailable</Trans>
          </Text>
        </ProductImageUnavailable>
      )}
    </>
  );
};
